import { render } from "./add-to-cart.vue?vue&type=template&id=0df12668"
import script from "./add-to-cart.vue?vue&type=script&lang=js"
export * from "./add-to-cart.vue?vue&type=script&lang=js"

import "./add-to-cart.vue?vue&type=style&index=0&id=0df12668&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__